<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2020-12-14 01:36:00
    Description : 个人中心
  -->
  <div class="main">
    <el-scrollbar style="height: 100vh">
      <gaia-header :isShowUpload="false" />
      <div class="background" :style="{ backgroundImage: backgroundImage }" />
      <div class="page">
        <div class="card">
          <div class="avatar">
            <img :src="user.avatar ? baseUrl + user.avatar : defaultAvatar" />
          </div>
          <div class="nickname">
            <span>
              {{ user.nickname || "Gaiamount" }}
            </span>
            <member-tag v-if="member" size="big" :type="member.memberType" />
          </div>
          <div class="job">{{ user.job || "职业" }}</div>
          <div class="introduce">{{ user.signature || "个性签名" }}</div>
          <el-divider />
          <div class="radio-group">
            <div
              class="item"
              :class="{ active: radioActive === 0 }"
              @click="radioClick(0)"
            >
              创作
            </div>
            <div
              class="item"
              :class="{ active: radioActive === 1 }"
              @click="radioClick(1)"
              v-if="isSelf"
            >
              动态
            </div>
            <div
              class="item"
              v-if="isSelf"
              :class="{ active: radioActive === 2 }"
              @click="radioClick(2)"
            >
              圈子
            </div>
            <div
              class="item"
              v-if="isSelf"
              :class="{ active: radioActive === 3 }"
              @click="radioClick(3)"
            >
              收藏
            </div>
            <div
              class="item"
              v-if="isSelf"
              :class="{ active: radioActive === 4 }"
              @click="radioClick(4)"
            >
              小组
            </div>
          </div>
          <div class="follow" v-if="!isSelf">
            <el-button
              :loading="followLoading"
              :type="followRes && followRes.followed ? 'info' : 'primary'"
              :icon="
                followRes && followRes.followed
                  ? 'el-icon-minus'
                  : 'el-icon-plus'
              "
              style="min-width: 100px"
              @click="follow"
            >
              {{ followRes && followRes.followed ? "取消关注" : "关注" }}
            </el-button>
          </div>
        </div>
      </div>
      <creation
        ref="creation"
        v-if="radioActive === 0"
        :id="id"
        :isSelf="isSelf"
      />
      <dynamic ref="dynamic" v-if="radioActive === 1" />
      <circles ref="circles" v-if="radioActive === 2" />
      <favorites ref="favorites" v-if="radioActive === 3" />
      <group ref="group" v-if="radioActive === 4" />
      <gaia-footer />
    </el-scrollbar>
  </div>
</template>

<script>
import gaiaHeader from "@/components/gaia-header/gaia-header";
import GaiaFooter from "@/components/gaia-footer/gaia-footer";
import { ThumbsUp } from "@icon-park/vue";
import { getPersonal, isFollow, follow } from "@/api/personal";
import Creation from "./creation.vue";
import MemberTag from "@/components/member-tag/member-tag";
import Dynamic from "./dynamic.vue";
import circles from "./circles.vue";
import Favorites from "./favorites.vue";
import Group from "./group.vue";
export default {
  components: {
    gaiaHeader,
    GaiaFooter,
    ThumbsUp,
    Creation,
    MemberTag,
    Dynamic,
    circles,
    Favorites,
    Group,
  },
  data() {
    return {
      url: "https://pub-glb.cn-e1.acs-cdn.gaiamount.com",
      baseUrl: process.env.VUE_APP_RESOURCES_URL,
      defaultAvatar: process.env.VUE_APP_DEFAULTAVATAR,
      id: 0,
      isSelf: true,
      user: {},
      member: {},
      radioActive: 0,
      backgroundImage: "",
      followRes: {},
      followLoading: false,
    };
  },
  created() {
    this.id = Number(this.$route.params.id);
    this.getPersonal();
    this.isFollow();
  },
  methods: {
    getPersonal() {
      getPersonal(this.id).then((res) => {
        // console.log(res);
        this.user = res.user;
        this.member = res.member;
        if (res.user.background) {
          this.backgroundImage = this.baseUrl + res.user.background;
        } else {
          this.backgroundImage = this.url + "/web/img/user-banner.jpg";
        }
        if (
          res.user.account.id ===
          JSON.parse(localStorage.getItem("user")).account.id
        ) {
          this.isSelf = true;
        } else {
          this.isSelf = false;
        }
        setTimeout(() => {
          this.$refs.creation.getList();
        }, 0);
      });
    },
    isFollow() {
      this.followLoading = true;
      isFollow(this.id)
        .then((res) => {
          this.followRes = res.follow;
          this.followLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.followLoading = false;
          this.$message.error("获取关注状态失败");
        });
    },
    follow() {
      this.followLoading = true;
      follow(this.id)
        .then((res) => {
          this.isFollow();
        })
        .catch((err) => {
          console.log(err);
          this.followLoading = false;
          this.$message.error("关注失败");
        });
    },
    radioClick(i) {
      this.radioActive = i;
      if (i === 0) {
        setTimeout(() => {
          this.$refs.creation.getList();
        }, 0);
      } else if (i === 3) {
        setTimeout(() => {
          this.$refs.favorites.getList();
        }, 0);
      }
    },
    /**
     * 批量管理里的分页
     */
  },
};
</script>
<style lang="less">
@import "@/assets/css/blackSelect.less";
</style>
<style lang="less" scoped>
.main {
  // width: 1300px;
  width: 100vw;
  height: 100vh;
  background: #ebebeb;
}
.background {
  min-width: 1300px;
  width: 100%;
  height: 570px;
  background-image: url(https://pub-glb.cn-e1.acs-cdn.gaiamount.com/web/img/user-banner.jpg);
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: 50%;
  padding-top: 170px;
}
.card {
  width: 1200px;
  height: 270px;
  margin: -170px auto 100px;
  padding: 0 80px;
  background: #ffffff;
  box-shadow: 0 2px 18px 0 rgba(0, 0, 0, 0.03);
  border-radius: 10px;
  .avatar {
    height: 120px;
    width: 120px;
    border-radius: 120px;
    overflow: hidden;
    display: inline-block;
    border: 4px solid #fff;
    margin-top: -80px;
    box-shadow: 0 0 10px hsl(0deg 0% 74% / 80%);
    img {
      width: 100%;
      height: 100%;
    }
  }
  .nickname {
    margin-top: 20px;
    font-size: 26px;
    color: #333333;
  }
  .job,
  .introduce {
    color: #616161;
    font-size: 14px;
    margin: 10px 0;
  }
  .follow {
    position: relative;
    display: inline-block;
    top: -220px;
    left: 900px;
    width: 0;
    height: 0;
    > .el-button {
      font-weight: bold;
    }
  }
}
.radio-group {
  .item {
    display: inline-block;
    margin-right: 55px;
    margin-top: 20px;
    font-weight: 700;
    color: #222222;
    font-size: 16px;
    padding: 0 0 4px;
    cursor: pointer;
    user-select: none;
  }
  .item.active {
    color: #ff464c;
  }
}
</style>